<template>
  <div class='main-box'>
    <img class='main-bk' :src="bkImg" alt=""/>
    <div class="main">
      <slot></slot>
    </div>
    <img class='back' v-if="backImg" @click="back" :src="backImg" alt=""/>
  </div>
</template>

<script setup >
import {useRouter} from "vue-router";
const router=useRouter()
const props=defineProps(['bkImg','backImg'])
const back=()=>{
  router.replace({name:'index'})
}
</script>

<style lang="less" scoped>
.main-box{
  width: 100vw;
  min-height: 100vh;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  position: relative;
  .back{
    width: 179px;
    position: absolute;
    z-index: 4;
    bottom: 50px;
    left:70px;
  }
}
.main-bk{
  width: 100vw;
  z-index: 1;
}
.main{
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100vw;
  flex: 1;
  z-index: 2;
  flex-direction: column;
  align-items: center;
}

</style>